/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BinderClaimPaymentHistoryResponseDto
 */
export interface BinderClaimPaymentHistoryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    claimPaymentId: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {Date}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    transactionType: BinderClaimPaymentHistoryResponseDtoTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    bankAccountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    settlementCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    paymentStatus: BinderClaimPaymentHistoryResponseDtoPaymentStatusEnum;
    /**
     * This Payment (Our Share) - sum of all loss types
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    thisPaymentOurShare: string;
    /**
     * Outstanding (Our Share) - sum of all loss types
     * @type {string}
     * @memberof BinderClaimPaymentHistoryResponseDto
     */
    outstandingOurShare: string;
}


/**
 * @export
 */
export const BinderClaimPaymentHistoryResponseDtoTransactionTypeEnum = {
    Payment: 'Payment',
    ReserveChangeOnly: 'Reserve Change Only'
} as const;
export type BinderClaimPaymentHistoryResponseDtoTransactionTypeEnum = typeof BinderClaimPaymentHistoryResponseDtoTransactionTypeEnum[keyof typeof BinderClaimPaymentHistoryResponseDtoTransactionTypeEnum];

/**
 * @export
 */
export const BinderClaimPaymentHistoryResponseDtoPaymentStatusEnum = {
    AwaitingApproval: 'Awaiting Approval',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Paid: 'Paid'
} as const;
export type BinderClaimPaymentHistoryResponseDtoPaymentStatusEnum = typeof BinderClaimPaymentHistoryResponseDtoPaymentStatusEnum[keyof typeof BinderClaimPaymentHistoryResponseDtoPaymentStatusEnum];


/**
 * Check if a given object implements the BinderClaimPaymentHistoryResponseDto interface.
 */
export function instanceOfBinderClaimPaymentHistoryResponseDto(value: object): value is BinderClaimPaymentHistoryResponseDto {
    if (!('claimPaymentId' in value) || value['claimPaymentId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('settlementCurrency' in value) || value['settlementCurrency'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('thisPaymentOurShare' in value) || value['thisPaymentOurShare'] === undefined) return false;
    if (!('outstandingOurShare' in value) || value['outstandingOurShare'] === undefined) return false;
    return true;
}

export function BinderClaimPaymentHistoryResponseDtoFromJSON(json: any): BinderClaimPaymentHistoryResponseDto {
    return BinderClaimPaymentHistoryResponseDtoFromJSONTyped(json, false);
}

export function BinderClaimPaymentHistoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderClaimPaymentHistoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimPaymentId': json['claimPaymentId'],
        'claimId': json['claimId'],
        'contractId': json['contractId'],
        'transactionDate': (new Date(json['transactionDate'])),
        'transactionType': json['transactionType'],
        'transactionId': json['transactionId'],
        'bankAccountNumber': json['bankAccountNumber'],
        'settlementCurrency': json['settlementCurrency'],
        'paymentStatus': json['paymentStatus'],
        'thisPaymentOurShare': json['thisPaymentOurShare'],
        'outstandingOurShare': json['outstandingOurShare'],
    };
}

export function BinderClaimPaymentHistoryResponseDtoToJSON(json: any): BinderClaimPaymentHistoryResponseDto {
    return BinderClaimPaymentHistoryResponseDtoToJSONTyped(json, false);
}

export function BinderClaimPaymentHistoryResponseDtoToJSONTyped(value?: BinderClaimPaymentHistoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimPaymentId': value['claimPaymentId'],
        'claimId': value['claimId'],
        'contractId': value['contractId'],
        'transactionDate': ((value['transactionDate']).toISOString()),
        'transactionType': value['transactionType'],
        'transactionId': value['transactionId'],
        'bankAccountNumber': value['bankAccountNumber'],
        'settlementCurrency': value['settlementCurrency'],
        'paymentStatus': value['paymentStatus'],
        'thisPaymentOurShare': value['thisPaymentOurShare'],
        'outstandingOurShare': value['outstandingOurShare'],
    };
}

